import { format, differenceInDays } from 'date-fns';
import { useMemo } from 'react';
import { FormattedDate } from './IdentificationRequestsDate.styles';

interface IRequestsDateState {
  requestDate: any;
}

const IdentificationRequestsDate = ({ requestDate }: IRequestsDateState) => {
  const numberOfDays = (date = new Date(), isLeapYear = 0) => {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      isLeapYear,
      0,
    );
  };

  const dateDifferences = differenceInDays(
    numberOfDays(),
    numberOfDays(requestDate, 23),
  );

  const date_status = useMemo((): '>2weeks' | '>3weeks' | '<2weeks' => {
    switch (true) {
      case dateDifferences >= 14 && dateDifferences < 21:
        return '>2weeks';
      case dateDifferences >= 21:
        return '>3weeks';
      default:
        return '<2weeks';
    }
  }, [dateDifferences]);

  return (
    <FormattedDate $dateState={date_status}>
      {format(requestDate, 'MM/dd/yyyy')}
    </FormattedDate>
  );
};

export { IdentificationRequestsDate };
